const config = {
  serverUrl: import.meta.env.PUBLIC_SERVER_URL || "http://localhost:8000",
};

export default config;
